import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useToast } from "@/hooks/use-toast";
import { shareResultToPatient } from "@/redux/actions/testKitActions";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const ShareResultToPatient = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const params = useParams();
  const dispatch: any = useDispatch();

  const { toast } = useToast();

  const handleSubmit = () => {
    dispatch(
      shareResultToPatient(
        Number(params.id),
        () => setIsOpen(false),
        () =>
          toast({
            variant: "destructive",
            description: "Error in sharing result to patient",
          })
      )
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary">Share Result to Patient</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share Result to Patient</DialogTitle>
          <DialogDescription>
            Share the result of the test kit to the patient.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="submit" onClick={() => handleSubmit()}>
            Share
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ShareResultToPatient;
